type TocItem = {
	id: string;
	text: string;
	level: number;
};

/**
 * マークダウンから目次を抽出する
 */
export const extractToc = (markdown: string): TocItem[] => {
	const headingRegex = /^(#{1,6})\s+(.+)$/gm;
	const toc: TocItem[] = [];
	let match: RegExpExecArray | null;

	while ((match = headingRegex.exec(markdown)) !== null) {
		const level = match[1].length;
		// HTMLタグを削除してテキストを取得
		const text = match[2].trim().replace(/<[^>]*>/g, "");
		// IDはテキストをスラッグ化（簡易版）
		const id = text
			.toLowerCase()
			.replace(/[^\w\s\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF-]/g, "")
			.replace(/\s+/g, "-");

		toc.push({ id, text, level });
	}

	return toc;
};
